import { type } from 'arktype'

import type { FrRcpwProductVersionFormat } from './model.ts'

export const frRcpwProductVersions = [
  'product-fr-rcp-wakam-1.0.0-2026-06-12',
] as const satisfies FrRcpwProductVersionFormat[]

export const frRcpwProductVersionSchema = type('===', ...frRcpwProductVersions)

export type FrRcpwProductVersion = typeof frRcpwProductVersionSchema.infer
